var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAppMajor = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79922 9.79922L0.199219 9.79922V1.99922C0.199219 1.00511 1.00511 0.199219 1.99922 0.199219H9.79922L9.79922 9.79922Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79922 12.1992L9.79922 21.7992H1.99922C1.00511 21.7992 0.199219 20.9933 0.199219 19.9992V12.1992H9.79922Z",
    fill: "#5C5F62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 12.1992V21.7992H19.9992C20.9933 21.7992 21.7992 20.9933 21.7992 19.9992V12.1992H12.1992Z",
    fill: "#5C5F62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9992 0.199219C17.662 0.199219 18.1992 0.736477 18.1992 1.39922V3.79922H20.5992C21.262 3.79922 21.7992 4.33648 21.7992 4.99922C21.7992 5.66196 21.262 6.19922 20.5992 6.19922H18.1992V8.59922C18.1992 9.26196 17.662 9.79922 16.9992 9.79922C16.3365 9.79922 15.7992 9.26196 15.7992 8.59922V6.19922H13.3992C12.7365 6.19922 12.1992 5.66196 12.1992 4.99922C12.1992 4.33648 12.7365 3.79922 13.3992 3.79922H15.7992V1.39922C15.7992 0.736477 16.3365 0.199219 16.9992 0.199219Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppMajor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/app-major.10724867.svg";
export { ForwardRef as ReactComponent };